<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<div class="mainList">
			<el-form label-width="80px" :inline="true" @submit.native.prevent style="margin-left: 13px;padding: 5px 0">
				<el-form-item
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value
					"
				>
          <InputTopTip v-model="selectedOptions" :placeholder="querylist">
            <el-cascader
              :key="refreshItem"
              ref="cascaderArr"
              placeholder=""
              v-model="selectedOptions"
              size="small"
              :options="options"
              :props="{
                value: 'id',
                label: 'name',
                children: 'child',
                expandTrigger: 'click',
                emitPath: false
              }"
              @change="handleChange($event)"
            >
            </el-cascader>
          </InputTopTip>
				</el-form-item>
				<el-form-item
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value
					"
				>
          <InputTopTip v-model="filter_form.name" placeholder="学校名字">
            <el-input
              style="width: 220px;"
              placeholder=""
              @keyup.native.enter=";(currentPage = 1), refreshDataList()"
              v-model="filter_form.name"
              size="small"
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
          <InputTopTip v-model="SearchGrade" placeholder="年级"
            v-if="
              $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
              $store.state.user.userInfo.type === $api.account.types.OTHER.value
            "
          >
            <el-select
              ref="SearchGrade"
              v-model="SearchGrade"
              style="width: 100px;"
              placeholder=""
              size="small"
              @change="SearchGradeChange"

            >
              <el-option v-for="d in gradesArr" :key="d.val" :label="d.name" :value="d.val" />
            </el-select>
          </InputTopTip>
          <InputTopTip v-model="SearchGrade" placeholder="年级" v-else>
            <el-select
              ref="SearchGrade"
              v-model="SearchGrade"
              style="width: 100px;"
              placeholder=""
              size="small"
              @change="SearchGradeChange"
            >
              <el-option v-for="d in filterGradesArr" :key="d.val" :label="d.name" :value="d.val" />
            </el-select>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
          <InputTopTip v-model="SearchClass" placeholder="班级">
            <el-select
              ref="SearchClass"
              style="width: 100px;"
              v-model="SearchClass"
              placeholder=""
              size="small"
              @change="SearchClassChange"
            >
              <el-option v-for="item in classNumber" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
					<!-- <el-input
						style="width: 200px;"
						:placeholder="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value || $store.state.user.userInfo.type === $api.account.types.OTHER.value ? '班内序号' : '班级序号'
						"
						v-model="filter_form.ClassesRadio"
						size="small"
					> -->
          <InputTopTip v-model="filter_form.ClassesRadio" placeholder="班内序号">
            <el-input
              style="width: 200px;"
              :placeholder="''"
              @keyup.native.enter="currentPage = 1, refreshDataList()"
              v-model="filter_form.ClassesRadio"
              size="small"
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
          <InputTopTip v-model="filter_form.studentname" placeholder="学生名字">
            <el-input
              style="width: 150px;"
              placeholder=""
              @keyup.native.enter="currentPage = 1, refreshDataList()"
              v-model="filter_form.studentname"
              size="small"
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </InputTopTip>
				</el-form-item>
        <el-form-item>
          <InputTopTip v-model="filter_form.fb_state" placeholder="学生状态">
            <el-select
              ref="SearchClass"
              style="width: 120px;"
              v-model="filter_form.fb_state"
              placeholder=""
              size="small"
              @change="() => { currentPage = 1, refreshDataList() }"
            >
              <el-option v-for="item in studentStatus" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>
			</el-form>

			<div style="display: flex; margin-left: auto;">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px;"
						@click=";(currentPage = 1), refreshDataList()"
						>搜索</el-button
					>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="clearList"
						>重置</el-button
					>
				</template>
			</div>
		</div>
		<div>
			<section class="list-area">
				<div class="list-area-otis" v-if="$permissions([SP33001, SP33002, SP33003, SP33004, SP33005])">
					<template>
						<div style="display: flex; padding-left: 18px;">
							<el-button
								type="primary"
								size="small"
								icon="el-icon-plus"
								style="margin-right: 15px;"
								@click="Newbuttont()"
								v-permission="SP33001"
								>新建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-download"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
								@click="$refs.importDialog.dialogVisible = true"
								v-permission="SP33002"
								>批量创建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-upload2"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
								@click="exportExcel('students', '学生数据')"
								v-permission="SP33003"
								v-if="multipleSelection.length > 0"
								>导出</el-button
							>
						</div>
						<div>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-delete"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="batchDelete()"
								v-if="multipleSelection.length > 0"
								v-permission="SP33004"
								>批量删除</el-button
							>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-refresh-right"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="batchResetPwd()"
								v-if="multipleSelection.length > 0"
								v-permission="SP33005"
								>重置密码</el-button
							>
						</div>
					</template>
				</div>
				<el-table
					:data="dataList"
					row-class-name="row"
					tooltip-effect="dark"
					@selection-change="handleSelectionChange"
					:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				>
					<el-table-column
						type="selection"
						width="60"
						align="center"
						v-if="$permissions([SP33003, SP33004, SP33005])"
					></el-table-column>
					<el-table-column
						align="left"
						label="学校名称"
						prop="school.name"
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type === $api.account.types.OTHER.value
						"
					/>
					<el-table-column
						align="left"
						label="辖区"
						prop="school.district_division"
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type === $api.account.types.OTHER.value
						"
					>
						<template slot-scope="scope">
							{{ scope.row.school.district_division.l1_name }}/{{ scope.row.school.district_division.l2_name }}{{
								scope.row?.school?.district_division?.l3_name ? '/' + scope.row?.school?.district_division?.l3_name : ''
							}}</template
						>
					</el-table-column>

					<el-table-column align="left" label="学生名字" prop="account.realname" />
					<el-table-column align="left" label="学籍号" prop="account.serial" />

					<el-table-column align="left" label="性别" prop="account.sex" :formatter="music_typeFormat" />
					<el-table-column align="left" label="班级" prop="classgrade.class_name" />
					<!-- <el-table-column
						align="left"
						:label="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value || $store.state.user.userInfo.type === $api.account.types.OTHER.value ? '班内序号' : '班级序号'
						"
						prop="number_in_class"
					/> -->
					<el-table-column align="left" :label="'班内序号'" prop="number_in_class" />
					<el-table-column align="center" label="微信授权">
						<template slot-scope="scope">
							<svg
								class="icon"
								v-if="scope.row.account != null"
								aria-hidden="true"
								style="width: 23px; height: 23px; outline: none; box-shadow: none;"
							>
								<use v-if="scope.row.account.openid === null" xlink:href="#icon-wechartstate"></use>
								<use v-else xlink:href="#icon-wechartstate2"></use>
							</svg>
							<svg
								class="icon"
								v-else
								aria-hidden="true"
								style="width: 23px; height: 23px; outline: none; box-shadow: none;"
							>
								<use xlink:href="#icon-wechartstate"></use>
							</svg>
						</template>
					</el-table-column>

					<el-table-column align="left" label="学生状态" prop="student_state"></el-table-column>
					<template v-if="$permissions([SP33006, SP33007, SP33008])">
						<el-table-column align="center" label="操作" class-name="opscol" width="230">
							<template v-slot:default="slot">
								<div class="table-mgn2" _flex="~ !justify-center">
									<div
										style="color: #ff7143;"
										@click="
											$router.push({
												name: 'studentDetail',
												query: { id: slot.row.uid }
											})
										"
									>
										<el-tooltip content="查看" placement="bottom" effect="light">
											<i aria-hidden="true" class="icon el-icon-view"></i>
										</el-tooltip>
									</div>
									<div style="color: #3f6af7;" @click="Editbutton(slot.row.uid)" v-permission="SP33006">
                    <!-- 1.4.5转校屏蔽 -->
                    <!-- v-if="slot.row.student_state == '未入学'" -->
										<el-tooltip content="编辑" placement="bottom" effect="light">
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconoutlinesetting"></use>
											</svg>
										</el-tooltip>
									</div>

                  <!-- 1.4.5转校屏蔽 -->
									<!-- <div v-if="
                    ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && slot.row.student_state == '就读中') ||
                    ($store.state.user.userInfo.type === $api.account.types.OTHER.value && slot.row.student_state == '就读中' && $permissions(['SP33009']))
                  " style="color: #37c89c;" @click="promptTurn(slot.row.uid)">
										<el-tooltip content="转校" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none;"
											>
												<use xlink:href="#icon-turn"></use>
											</svg>
										</el-tooltip>
									</div> -->

									<div
										class="icon delete"
										style="color: #f13048;"
										@click="promptRemove(slot.row.uid)"
										v-permission="SP33007"
									>
                    <!-- 1.4.5转校屏蔽 -->
                    <!-- v-if="slot.row.student_state == '未入学'" -->
										<el-tooltip content="删除" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none;"
											>
												<use xlink:href="#icon-deltred"></use>
											</svg>
										</el-tooltip>
									</div>
									<div style="color: #666666;" @click="resetPwd(slot.row.uid)" v-permission="SP33008">
										<el-tooltip content="重置" placement="bottom" effect="light">
											<i aria-hidden="true" class="icon el-icon-refresh-right"></i>
										</el-tooltip>
									</div>
								</div>
							</template>
						</el-table-column>
					</template>
				</el-table>
				<div class="pagination-page">
					<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
					<el-pagination
						class="pagination"
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-size="pageSize"
						:total="totalItems"
						:current-page.sync="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						layout="prev,pager,next,jumper,sizes"
						style="margin-top: 21px; margin-left: 10px;"
					>
					</el-pagination>
				</div>
			</section>
		</div>

		<el-dialog
			class="practice-sheet-new-edit-dialog"
			width="540px"
			:close-on-click-modal="false"
			:visible.sync="practiceSheetNewEditDialog"
			:destroy-on-close="true"
			@close="practiceSheetNewEditDialogClose"
		>
			<div class="dialog-title2" slot="title">
				<span>{{ dialogTitleType }}</span>
				<el-divider></el-divider>
			</div>
			<template>
				<el-form
					:model="model"
					ref="newForm"
					:rules="vaRules"
					@submit.native.prevent="confirm"
					label-position="right"
					label-width="70px"
				>
					<el-form-item prop="name" label="真实姓名">
            <InputTopTip v-model="model.name" placeholder="真实姓名">
						  <el-input placeholder="" v-model="model.name" style="width: 100%;" size="medium" />
            </InputTopTip>
					</el-form-item>

					<el-form-item label="性别" prop="sexs" style="margin-top: 25px;">
            <InputTopTip v-model="model.sexs" placeholder="性别">
              <el-select v-model="model.sexs" style="width: 100%;" placeholder="" size="small" @change="radiohandle3">
                <el-option v-for="d in sexArr" :key="d.val" :label="d.name" :value="d.val" />
              </el-select>
            </InputTopTip>
					</el-form-item>

					<el-form-item
						label="学校"
						prop="schoolname"
						style="margin-top: 25px;"
						v-if="
							$store.state.user.userInfo.type == $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type == $api.account.types.OTHER.value
						"
					>
            <InputTopTip v-model="model.schoolname" placeholder="学校名称">
              <el-autocomplete
                placeholder=""
                v-model="model.schoolname"
                style="width: 100%;"
                size="medium"
                :fetch-suggestions="querySearchAsync"
                :trigger-on-focus="false"
                @select="handleSelect"
                ref="myAutocomplete"
              >
                <template slot-scope="{ item }">
                  {{ item.value }}---------<span class="addr">{{ item.address }}</span>
                </template>
              </el-autocomplete>
            </InputTopTip>
					</el-form-item>

					<el-form-item
						label="辖区"
						prop="newselectedOptions"
						style="margin-top: 25px;"
						v-if="
							$store.state.user.userInfo.type == $api.account.types.PLATFORM_ADMIN.value ||
							$store.state.user.userInfo.type == $api.account.types.OTHER.value
						"
					>
						<div :class="arereid === 2 ? 'arere' : ''">
              <InputTopTip v-model="newselectedOptions" :placeholder="'辖区'">
                <el-cascader
                  :disabled="true"
                  ref="areaRef"
                  v-model="newselectedOptions"
                  style="width: 100%;"
                  size="medium"
                  placeholder=""
                  :options="options2"
                  :props="{
                    value: 'id',
                    label: 'name',
                    children: 'child',
                    emitPath: false
                  }"
                  @expand-change="expandleChange(options2)"
                  @change="handleChange2($event)"
                />
              </InputTopTip>
						</div>
					</el-form-item>

					<el-form-item
						label="年级"
						prop="periodNj"
						style="margin-top: 25px;"
						v-if="SchoolId && model.schoolname != ''"
					>
            <InputTopTip v-model="model.periodNj" placeholder="年级">
              <el-select
                v-model="model.periodNj"
                style="width: 100%;"
                placeholder=""
                size="small"
                @change="radiohandle"
              >
                <el-option v-for="d in filterGradesArr" :key="d.val" :label="d.name" :value="d.val" />
              </el-select>
            </InputTopTip>
					</el-form-item>

					<el-form-item
						label="班级"
						prop="periodBj"
						style="margin-top: 25px;"
						v-if="model.periodNj && model.schoolname != ''"
					>
            <InputTopTip v-model="model.periodBj" placeholder="班级">
              <el-select
                v-model="model.periodBj"
                style="width: 100%;"
                placeholder=""
                size="small"
                @change="radiohandle2"
              >
                <el-option v-for="item in cities" :key="item.id" :label="item.class_name" :value="item.id"></el-option>
              </el-select>
            </InputTopTip>
					</el-form-item>

					<el-form-item label="班内序号" prop="serialnumber" style="margin-top: 25px;">
            <InputTopTip v-model="model.serialnumber" placeholder="班内序号">
              <el-input
                placeholder=""
                v-model="model.serialnumber"
                @input="e => (model.serialnumber = numberCheck(e))"
                style="width: 100%;"
                size="medium"
              />
            </InputTopTip>
					</el-form-item>

					<el-form-item label="学籍号" prop="statusnumber" style="margin-top: 25px;">
            <InputTopTip v-model="model.statusnumber" placeholder="学籍号">
              <el-input
                placeholder=""
                :maxlength="25"
                :minlength="5"
                v-model="model.statusnumber"
                @input="e => (model.statusnumber = validForbid(e))"
                style="width: 100%;"
                size="medium"
              />
            </InputTopTip>
					</el-form-item>

					<div style="margin-top: 25px;">
						<el-divider></el-divider>
					</div>
					<el-form-item
						style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;"
					>
						<el-button
							class="btn-close"
							@click="practiceSheetNewEditDialogClose"
							style="width: 80px; height: 32px; line-height: 1px;"
							>取 消</el-button
						>
						<el-button
							class="btn-prim"
							type="primary"
							native-type="submit"
							style="width: 80px; height: 32px; line-height: 1px;"
							>{{ onTitleType }}</el-button
						>
					</el-form-item>
				</el-form>
			</template>
		</el-dialog>
		<!-- 批量导入 -->
		<batch-import-account ref="importDialog" :target="'student'" />
	</main>
</template>
<script>
import { SP33001, SP33002, SP33003, SP33004, SP33005, SP33006, SP33007, SP33008 } from '@/utils/permissionMap.js'
import BatchImportAccount from '@/components/BatchImportAccount'
import { throttle } from 'lodash'
import { exportXLS } from '@/utils/job.js'
const wechatrstate = require('@/assets/test_client/Frame.png')
const wechatrstate2 = require('@/assets/test_client/Frame2.png')
const cityOptions = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10']
import { studentStatus } from './const.js'
const primarySchool = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' }
]
const middleSchool = [
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' }
]
const highSchool = [
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
const gradesArr = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' },
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' },
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
const sexArr = [
	{ val: 0, name: '未知' },
	{ val: 1, name: '男' },
	{ val: 2, name: '女' }
]

export default {
	props: [],
	data() {
		return {
			SP33001,
			SP33002,
			SP33003,
			SP33004,
			SP33005,
			SP33006,
			SP33007,
			SP33008,
			classNumber: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
      studentStatus,
			querylist: '省 / 市 / 区',
			wechatrstate,
			wechatrstate2,
			areaOptions: {},
			selectedOptions: [], //列表省市区
			listId: null,
			refreshItem: 0,
			options: [],
			options2: [],
			options3: [],
			arereid: 1, //编辑辖区颜色id
			//新建省市区
			newareaOptions: {},
			newselectedOptions: [],
			checkList: [],
			checkList1: [],
			newlistId: null,
			model: {
				name: '',
				schoolname: '',
				serialnumber: '',
				statusnumber: '',
				period: null,
				periodNj: null,
				sexs: null,
				periodBj: '',
				Perfect: '省 / 市 / 区' //回显省市区
			},
			EditId: null,
			SchoolId: null,
			classId: null,
			sexid: null,
			vaRules: {
				name: [
					{
						required: true,
						message: '请输入真实姓名',
						trigger: 'change'
					}
				],
				serialnumber: [
					{
						required: true,
						message: '请输入班内序号',
						trigger: 'change'
					}
				],

				statusnumber: [
					{
						required: true,
						message: '请输入学籍号',
						trigger: 'change'
					},
					// { required: true, min: 5, max: 25, message: '至少5位字符，且不能超过25个字符', trigger: ['blur', 'change'] },
					{ required: true, pattern: '^[^\u4e00-\u9fa5]{5,25}$', message: '请输入5-25位数字或大小写字母', trigger: 'change' }
				],
				schoolname: [
					{
						required: true,
						message: '未选择学校，请输入学校后在下拉框选择对应学校',
						trigger: 'change'
					}
				],
				periodNj: [
					{
						required: true,
						message: '请选择一个年级',
						trigger: 'change'
					}
				],
				sexs: [
					{
						required: true,
						message: '请选择学生性别',
						trigger: 'change'
					}
				],

				periodBj: [
					{
						required: true,
						message: '请选择一个班级',
						trigger: 'change'
					}
				]
			},
			dialogTitleType: '', //新建||编辑
			onTitleType: '', //确定||更新
			activeTab: 'personal',
			filter_form: {
				name: '',
				bureauFilter: null,
				bureauFilter2: null,
				studentname: '',
				ClassesRadio: ''
			},
			bureauList: [],
			dataList: [],
			pageSize: 10,
			totalItems: 0,
			currentPage: 1, // 第几页
			multipleSelection: [], // 批量删除
			currentPracticeSheetObj: null,
			dialogVisible: false,
			practiceSheetNewEditDialog: false, //设置新建班级弹窗
			checkAll: false, //全选
			isIndeterminate: false, //全选
			cities: [],
			gradesArr,
			primarySchool,
			middleSchool,
			highSchool,
			filterGradesArr: [], // 进行过过滤的年级枚举
			sexArr,
			SearchClass: null, //搜索班级ID
			SearchGrade: null //搜索年级ID
		}
	},
	components: {
		BatchImportAccount
	},
	watch: {
		newlistId: {
			handler: async function (val) {
				if (!this.practiceSheetNewEditDialog) return
				let res = null
				res = await this.$api.school.list({
					fu_name: this.model.schoolname,
					region_code: val
				})
				let result = res.data.map(item => {
					return {
						value: item.name,
						id: item.id,
						address: item.district_division.l1_name + item.district_division.l2_name + item.district_division.l3_name,
						middle_school: item.middle_school,
						high_school: item.high_school,
						primary_school: item.primary_school
					}
				})
				this.$refs['myAutocomplete'].suggestions = result
			}
		}
	},
	created() {
		/* this.getNewAreaOptions()
		this.getAreaOptions() */
		this.RegionalLevel()

		// 校管回显
		const userInfo = this.$store.state.user.userInfo
		if (userInfo?.school_admin?.length >= 1) {
			const schoolInfo = userInfo?.school_admin[0]
			this.model.schoolname = schoolInfo.school.name
			this.model.id = schoolInfo.school_id
			this.$set(this.model, 'schoolname', schoolInfo.school.name)
			this.$set(this.model, 'id', schoolInfo.school_id)
			this.SchoolId = schoolInfo.school_id
			this.newlistId = schoolInfo.school.region_code
			this.filterGradesArr = [
				...(schoolInfo.school.primary_school ? primarySchool : []),
				...(schoolInfo.school.middle_school ? middleSchool : []),
				...(schoolInfo.school.high_school ? highSchool : [])
			]
		}
		// 教师回显
		if (userInfo?.teachers?.length >= 1) {
			const teachers = userInfo?.teachers[0]
			this.SchoolId = teachers.school_id
			this.model.schoolname = teachers.school.name
			this.model.id = teachers.school_id
			this.$set(this.model, 'schoolname', teachers.school.name)
			this.$set(this.model, 'id', teachers.school_id)
			this.newlistId = teachers.school.region_code
			this.filterGradesArr = [
				...(teachers.school.primary_school ? primarySchool : []),
				...(teachers.school.middle_school ? middleSchool : []),
				...(teachers.school.high_school ? highSchool : [])
			]
		}

		if (this.$route.query?.studentlist?.district_division != undefined) {
			this.listId = this.$route.query.studentlist.district_division.code
			// this.querylist =
			// 	this.$route.query.studentlist.district_division.l1_name +
			// 	'/' +
			// 	this.$route.query.studentlist.district_division.l2_name +
			// 	'/' +
			// 	this.$route.query.studentlist.district_division.l3_name
			this.filter_form.name = this.$route.query.studentlist.name
      this.selectedOptions = Number(this.listId) ? Number(this.listId) : []
      this.refreshDataList()
      return
		}

    try {
      const { school_name, name, fb_state, fu_number_in_class, region_code, page, page_size, grade, seq } = this.$store.state.searchParams[this.$route.name]
      this.pageSize = page_size
      this.filter_form.studentname = name
      this.filter_form.name = school_name
      this.SearchGrade = grade
      this.SearchClass = seq
      this.listId = region_code
      this.selectedOptions = Number(this.listId) ? Number(this.listId) : []
      this.filter_form.ClassesRadio = fu_number_in_class
      this.filter_form.fb_state = fb_state
      this.currentPage = page
		  this.refreshDataList()
    } catch(err) {
      console.log('正常~')
      this.refreshDataList()
    }
	},
	methods: {
		numberCheck(num) {
			let checkNum = num.replace(/\D/g, '')
			if (num < 1) {
				checkNum = ''
			} else if (num >= 999999) {
				checkNum = 999999
			}
			return checkNum
		},
		async getClassNumber() {
			const data = await this.$api.classgrade.classGrdeNumber({
				grade: this.SearchGrade,
				school_id: this.SchoolId || ''
			})
			this.classNumber = data
		},
		async RegionalLevel() {
			this.$api.school
				.ssxlist(0)
				.then(res => {
					this.options = this.removeEmptyItems(res)
					this.options3 = res
				})
				.catch(err => {
					console.log('获取列表报错')
				})
		},
    removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.child?.length >= 1) {
					item.child = this.removeEmptyItems(item.child)
				} else {
					item.child = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
		async exportExcel(key, fileName) {
			// let text = this.multipleSelection.length > 0 ? '已选择' : '全部'
			// this.$confirm(`此操作将导出${text}的教师数据，是否继续?`, '温馨提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	type: 'warning'
			// })
      const tiemstamp = new Date()
      let job = {
        job_id: tiemstamp.getTime(),
        created_at: tiemstamp,
        progress: 0,
        name: fileName,
        type: 'XLS',
      }
      let ids = this.multipleSelection.map(item => {
        return item.uid
      })
			this.$confirm(`是否要导出登录密码?`, '温馨提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			})
				.then(async () => {
				  exportXLS(this, { ...job, msgType: key, prop: { has_password: true, ids } })
				})
				.catch(async action => {
					if (action === 'close') {
						return
					}
          exportXLS(this, { ...job, msgType: key, prop: { has_password: false, ids } })
				})
        .finally(() => {
          this.$store.state.job.isDot = true
        })
		},
		downloadFile(blob, fileName) {
			const url = window.URL.createObjectURL(new Blob([blob]))
			let a = document.createElement('a')
			a.href = url
			// 保证下载文件后缀一致
			a.download = `${fileName}.xlsx`
			a.click()
			window.URL.revokeObjectURL(url)
		},

		async querySearchAsync(queryString, cb) {
			let param = {
				name: queryString
			}
			this.$set(this.model, 'periodNj', '')
			this.$set(this.model, 'periodBj', '')
			let res = null
			res = await this.$api.school.list({
				fu_name: param.name,
				page_size: 99
				// region_code: this.newlistId
			})
			let result = res.data.map(item => {
				return {
					value: item.name,
					id: item.id,
					address: item.district_division.l1_name + item.district_division.l2_name + (item.district_division.l3_name || ''),
					addressInputValue:
						item.district_division.l1_name +
						' / ' +
						item.district_division.l2_name +
						(item.district_division.l3_name ? ' / ' + item.district_division.l3_name : ''),
					addressId: item.district_division.l3_id ? [item.district_division.l1_id, item.district_division.l2_id, item.district_division.l3_id] : [item.district_division.l1_id, item.district_division.l2_id],
					middle_school: item.middle_school,
					high_school: item.high_school,
					primary_school: item.primary_school
				}
			})
			if (this.timer) {
				clearTimeout(this.timer)
			}
			this.timer = setTimeout(() => {
				cb(result)
			}, 300)
		},
		handleSelect(item) {
      if (!item?.addressId) {
        return
      }
			this.classId = ''
			this.$set(this.model, 'periodNj', '')
			this.$set(this.model, 'periodBj', '')
			this.$refs['myAutocomplete'].activated = false
			this.model.Perfect = item.addressInputValue
			this.model.id = item.id
			this.SchoolId = item.id
			// 省市区回显~傻逼逻辑~傻逼
			this.newselectedOptions = item.addressId
			this.$refs['areaRef'].inputValue = this.model.Perfect
			this.newlistId = item.addressId[item.addressId.length - 1]
			// 年级根据学校字段进行筛选
			this.filterGradesArr = [
				...(item.primary_school ? primarySchool : []),
				...(item.middle_school ? middleSchool : []),
				...(item.high_school ? highSchool : [])
			]
			this.bureauList = []
			item.primary_school && this.bureauList.push({ val: 1, name: '小学' })
			item.middle_school && this.bureauList.push({ val: 2, name: '初中' })
			item.high_school && this.bureauList.push({ val: 3, name: '高中' })
			this.model.period = this.bureauList[0].val
		},
		//全选
		handleCheckAllChange(val) {
			this.checkList = val ? cityOptions : []
			this.isIndeterminate = false
		},
		//单选
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length
			this.checkAll = checkedCount === this.cities.length
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
		},
		getAreaData(data = { deep: 0, value: 0, code: null }) {
			return new Promise(resolve => {
				this.$api.school.ssxlist(data.value).then(res => {
					resolve(res && res && res) // 将获取到的数据传出
				})
			})
		},
		getAreaOptions() {
			let _this = this
			this.areaOptions = {
				lazy: true,
				lazyLoad(node, resolve) {
					const { level } = node
					// 调用后端接口获取数据
					_this.getAreaData(node.data).then(data => {
						const nodes = data.map(item => ({
							leaf: level >= 2,
							label: item.name,
							value: item.id,
							code: item.code,
							level
						}))
						resolve(nodes)
					})
				}
			}
		},
		getnewAreaData(data = { deep: 0, value: 0 }) {
			return new Promise(resolve => {
				this.$api.school.ssxlist(data.value).then(res => {
					resolve(res && res && res) // 将获取到的数据传出
				})
			})
		},
		getNewAreaOptions() {
			let _this = this
			this.newareaOptions = {
				lazy: true,
				lazyLoad(node, resolve) {
					const { level } = node
					// 调用后端接口获取数据
					_this.getnewAreaData(node.data).then(data => {
						const nodes = data.map(item => ({
							leaf: level >= 2,
							label: item.name,
							value: item.id,
							code: item.code,
							level
						}))
						resolve(nodes)
					})
				}
			}
		},
		async radiohandle(id) {
			let res = null
			res = await this.$api.classgrade.list({
				grade: id,
				fb_school_id: this.SchoolId,
				page: 1,
				page_size: 998
			})
			this.cities = res.data
			if (res.data.length > 0) {
				this.model.periodBj = res.data[0].class_name
				this.classId = res.data[0].id
			} else {
				this.model.periodBj = ''
			}
		},
		radiohandle2(id) {
			this.classId = id
		},

		radiohandle3(id) {
			this.sexid = id
		},

		//新建班级按钮
		Newbuttont() {
			this.arereid = this.practiceSheetNewEditDialog = true
			this.dialogTitleType = '新建'
			this.onTitleType = '创建'
			this.options2 = this.options3
		},
		//编辑班级按钮
		async Editbutton(id) {
			this.arereid = 2
			this.dialogTitleType = '编辑'
			this.onTitleType = '更新'
			this.practiceSheetNewEditDialog = true
			this.options2 = this.options3
			this.EditId = id
			let res = null
			res = await this.$api.student.showto(id)
      this.newselectedOptions = Number(res.school.district_division.code) // 修复辖区展示为空
			if (this.dialogTitleType === '编辑') {
				this.model.name = res.account.realname
				this.model.schoolname = res.school.name
				if (res.classgrade.grade_number === 0) {
					this.model.periodNj = 1
				} else {
					this.model.periodNj = res.classgrade.grade_number
				}

				this.model.sexs = res.account.sex
				this.model.periodBj = res.classgrade.class_name
				this.model.serialnumber = res.number_in_class
				this.model.statusnumber = res.account.serial
				this.SchoolId = res.school.id
				this.classId = res.classgrade.id
				this.sexid = res.account.sex

				this.filterGradesArr = [
					...(res.school.primary_school ? primarySchool : []),
					...(res.school.middle_school ? middleSchool : []),
					...(res.school.high_school ? highSchool : [])
				]
			}
			// eslint-disable-next-line no-unused-vars
			for (let i in res.school.district_division) {
				var arr = [] //声明一个新的数组
				arr.push({
					province: res.school.district_division.l1_name, //把省份保存到新的数组里
					city: res.school.district_division.l2_name, //把市保存到新的数组里
					county: res.school.district_division.l3_name //把区保存到新的数组里
				})
			}
			//进一步处理成可以回显的数据
			arr.map(item => {
				this.model.Perfect = item.province + ' / ' + item.city + ' / ' + item.county
			})
			let res2 = null
			res2 = await this.$api.classgrade.list({
				grade: this.model.periodNj,
				fb_school_id: this.SchoolId
			})
			this.cities = res2.data
		},
		expandleChange(list) {
			for (var i = 0; i < list?.length; i++) {
				if (list[i].child?.length < 1) {
					list[i].child = undefined
				} else {
					this.expandleChange(list[i]?.child)
				}
			}
			return list
		},
		handleChange(row) {
			const checkedNode = this.$refs['cascaderArr'].getCheckedNodes()
			this.listId = checkedNode[0].data.code
			this.refreshDataList()
		},
		handleChange2(row) {
			try {
				const checkedNode = this.$refs['areaRef'].getCheckedNodes()
				this.newlistId = checkedNode[0].data.code
			} catch (err) {
				console.log('辖区回显', err)
			}
		},
		practiceSheetNewEditDialogClose() {
			this.currentPracticeSheetObj = null
			this.practiceSheetNewEditDialog = false
			this.EditId = null

			// 只有管理员才需要更新学校的字段展示
			if (this.$store.state.user.userInfo.type == this.$api.account.types.PLATFORM_ADMIN.value) {
				this.SchoolId = ''
				this.$set(this.model, 'schoolname', '')
			}

			// this.SchoolId = null
			// this.model.name = ''
			this.model.Perfect = '省 / 市 / 区'

			this.classId = null
			this.$set(this.model, 'periodNj', '')
			this.$set(this.model, 'periodBj', '')

			this.sexid = null
			this.$refs['newForm'].resetFields()
			this.newselectedOptions = []
			this.options2 = null
			this.checkList = []
			this.cities = null
			this.newlistId = null
			this.dialogTitleType = ''
		},

		confirm: throttle(function () {
			this.$refs['newForm'].validate(async valid => {
				if (valid) {
					if (this.onTitleType == '创建') {
						if (this.$store.state.user.userInfo.type !== this.$api.account.types.TEACHER.value) {
							if (this.model.id != null) {
								this.$api.student
									.create({
										school_id: this.model.id,
										number_in_class: this.model.serialnumber,
										class_grade_id: this.classId,
										account: {
											serial: this.model.statusnumber,
											realname: this.model.name,
											sex: this.sexid
										}
									})
									.then(cRes => {
										this.practiceSheetNewEditDialogClose()
										// this.refreshDataList1()
                    this.refreshDataList()
									})
							} else {
								this.model.schoolname = ''
							}
						} else if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value) {
							this.$api.student
								.create({
									number_in_class: this.model.serialnumber,
									class_grade_id: this.classId,
									account: {
										serial: this.model.statusnumber,
										realname: this.model.name,
										sex: this.sexid
									}
								})
								.then(cRes => {
									this.practiceSheetNewEditDialogClose()
									// this.refreshDataList1()
                  this.refreshDataList()
								})
						}
					} else if (this.onTitleType == '更新') {
						if (this.$store.state.user.userInfo.type !== this.$api.account.types.TEACHER.value) {
							this.$api.student
								.update(this.EditId, {
									school_id: this.SchoolId,
									number_in_class: this.model.serialnumber,
									class_grade_id: this.classId,
									account: {
										serial: this.model.statusnumber,
										realname: this.model.name,
										sex: this.sexid
									}
								})
								.then(cRes => {
									this.practiceSheetNewEditDialogClose()
									this.refreshDataList1()
								})
						} else if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value) {
							this.$api.student
								.update(this.EditId, {
									number_in_class: this.model.serialnumber,
									class_grade_id: this.classId,
									account: {
										serial: this.model.statusnumber,
										realname: this.model.name,
										sex: this.sexid
									}
								})
								.then(cRes => {
									this.practiceSheetNewEditDialogClose()
									this.refreshDataList1()
								})
						}
					}
				} else {
					console.log('error')
				}
			})
		}, 3000),
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//每页下拉只显示的数据
		handleSizeChange(val) {
			this.currentPage = 1
			this.pageSize = val
			this.refreshDataList()
		},
		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.refreshDataList()
		},
		async refreshDataList() {
			let res = null
      const params = {
				page: this.currentPage,
				page_size: this.pageSize,
				name: this.filter_form.studentname,
				school_name: this.filter_form.name,
				grade: this.SearchGrade,
				seq: this.SearchClass,
				fu_number_in_class: this.filter_form.ClassesRadio,
				region_code: this.listId,
        fb_state: this.filter_form.fb_state
			}
      this.$store.commit('setSearchParams', { key: this.$route.name, params})
			res = await this.$api.student.list(params)
			this.totalItems = res.meta.total
			this.pageSize = parseInt(res.meta.per_page)
			this.dataList = res.data
		},
		async refreshDataList1() {
			let res = null
			res = await this.$api.student.list({
				page: this.currentPage,
				page_size: this.pageSize,
				name: null,
				school_name: null,
				grade: null,
				seq: null,
				number_in_class: null,
				region_code: null
			})
			this.totalItems = res.meta.total
			this.pageSize = parseInt(res.meta.per_page)
			this.dataList = res.data
		},
		clearList() {
			this.filter_form.name = ''
      this.filter_form.fb_state = ''
			this.filter_form.studentname = ''
			this.filter_form.ClassesRadio = ''
			this.listId = null
			this.SearchClass = null
			this.SearchGrade = null
			this.selectedOptions = []
			this.filter_form.bureauFilter2 = []
			this.filter_form.bureauFilter = []
			this.querylist = '省 / 市 / 区'
			this.refreshItem++, this.refreshDataList()
		},
		//班级
		SearchClassChange(val) {
			this.SearchClass = val
			this.currentPage = 1
			this.refreshDataList()
		},
		//年级
		SearchGradeChange(val) {
			this.SearchGrade = val
			this.$set(this.filter_form, 'bureauFilter2', '')
			this.SearchClass = ''
			this.currentPage = 1
			this.getClassNumber()
			this.refreshDataList()
		},

		resetPwd(id) {
			this.$confirm('此操作将重置密码, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					this.$api.teacher
						.ResetPwd({
							ids: [id]
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.refreshDataList()
								this.$message({
									message: '重置密码成功，密码为：000000',
									type: 'success'
								})
							}
						})
				})
				.catch(() => {})
		},
		//批量删除数据
		batchDelete() {
			this.$confirm('此操作将永久删除该学生以及附属数据, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					let idse = this.multipleSelection.map(item => item.uid)
					this.$api.student
						.StudentDeletes({
							ids: idse
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.$message.success('删除成功，请刷新数据')
								this.currentPage = 1
								this.refreshDataList()
								/* this.$message({
									message: '删除成功',
									type: 'success'
								}) */
							}
						})
				})
				.catch(() => {})
		},
		//批量重置密码
		batchResetPwd() {
			this.$confirm('此操作将重置密码, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					let idse = this.multipleSelection.map(item => item.uid)
					this.$api.teacher
						.ResetPwd({
							ids: idse
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.refreshDataList()
								this.$message({
									message: '重置密码成功，密码为：000000',
									type: 'success'
								})
							}
						})
				})
				.catch(() => {})
		},
		promptRemove(id) {
			this.$confirm('此操作将永久删除该学生以及附属数据, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.student.delete(id)
				this.$message.success('删除成功，请刷新数据')
				// 刷新
				this.refreshDataList()
			})
		},
		promptTurn(id) {
			this.$confirm('是否对该学生进行转校操作？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.student.updateState(id)
				this.$message.success('操作成功，请刷新数据')
				this.refreshDataList()
			})
		},
		music_typeFormat(row, column) {
			if (row.account.sex === 1) {
				return '男'
			} else if (row.account.sex === 2) {
				return '女'
			} else if (row.account.sex === 0) {
				return '未知'
			}
		}
	}
}
</script>
<style lang="scss" scoped>
// .arere {
// 	/deep/ .el-cascader .el-input .el-input__inner::placeholder {
// 		color: #323232;
// 	}
// }

.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}
.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
	content: '';
	width: 0px;
	margin-right: 0px;
}
.addr {
	font-size: 14px;
	color: #b4b4b4;
}
.schoolNianji {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
}
.schollAxie {
	height: 35px;
	display: flex;
	-webkit-box-pack: justify;
	justify-content: space-between;
	vertical-align: middle;
	-webkit-box-align: center;
	align-items: center;
}
.schollApex {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
	display: flex;
}
.el-form-item {
	margin-bottom: 1px;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}
.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}
.ClassesRadio {
	margin-right: 32px;
	padding-bottom: 15px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
.ClassChekbox {
	margin-right: 8px;
	width: 90px;
	height: 32px;
	padding-bottom: 0px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
</style>
